import React from 'react';
import { IconTypes } from 'external-services/icons-service/icons.types';

export const classPrefix = 'ActionButton';
export enum IconPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
export enum TooltipPosition {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom',
}
export enum ButtonColors {
  NONE = 'none',
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
  STANDBYBLUE = 'standbyBlue',
}
export interface IActionButton {
  variant: 'primary' | 'secondary';
  size: 'small' | 'regular' | 'large';
  handleClick?: (data?: any) => void; // ignored if useAnchorHref is set & mandatory when it is not set
  useAnchorHref?: string;
  maxWidth?: number;
  fullWidth?: boolean;
  text?: string;
  icon?: IIcon;
  tooltip?: ITooltip;
  loading?: boolean;
  disabled?: boolean;
  useSingleLineTruncation?: boolean;
  colorOverride?: ButtonColors;
  inButtonGroup?: boolean;
  useBorderRadiusV2?: boolean;
  useThemeColor?: boolean;
  useGreyBolderColor?: boolean;
  useBlackFontColor?: boolean;
  isHide?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement>;
}
export interface IIcon {
  iconPosition: IconPosition;
  iconAriaLabel?: string;
  iconType: IconTypes;
}
export interface ITooltip {
  title: string;
  position: TooltipPosition;
}
export interface IButtonProps {
  startIcon?: any;
  endIcon?: any;
  onClick: () => void;
  disabled: boolean;
  className: any;
  href?: string;
  variant: 'contained' | 'outlined' | 'text';
  target?: string;
  style: React.CSSProperties;
}
